import ImageChunk from './ImageChunk';

export default ImageChunk;
